import React, { useMemo } from 'react'
import { FormControl } from '@mui/material'
import { Button } from 'components/ui/button'
import { Slider } from 'components/ui/slider'
import { getRandomValue } from 'utils/formatUtils'

//  static label
const LABEL_MAPS = {
  video_length: { left: 'Shorter', right: 'Longer' },
  frames: { left: 'Shorter', right: 'Longer' },
  guidance_scale: { left: 'Creative', right: 'Precise' },
  embedded_guidance_scale: { left: 'Creative', right: 'Precise' },
  infer_steps: { left: 'Faster', right: 'Better' },
  num_inference_steps: { left: 'Faster', right: 'Better' },
  flow_shift: { left: 'Minimal', right: 'Maximum' },
}

// default max and min
const DEFAULT_MAX_MIN = {
  float: { min: 0, max: 1 },
  num_samples: { min: 1, max: 4 },
  default: { min: 0, max: 100 },
}

const RangeType = ({ itemKey, type, value, min, max, onChange }) => {
  // Set defaults using the static object
  const effectiveMax = useMemo(() => max ?? DEFAULT_MAX_MIN?.max ?? DEFAULT_MAX_MIN.default.max, [max])
  const effectiveMin = useMemo(() => min ?? DEFAULT_MAX_MIN?.min ?? DEFAULT_MAX_MIN.default.min, [min])

  // Convert string value to number if necessary
  const numericValue = useMemo(
    () => (typeof value === 'string' ? parseFloat(value) || effectiveMin : value),
    [value, effectiveMin]
  )

  const labels = useMemo(() => {
    return (
      LABEL_MAPS[itemKey] || {
        left: effectiveMin.toString(),
        right: effectiveMax.toString(),
      }
    )
  }, [itemKey, effectiveMin, effectiveMax])

  const handleRandomClick = () => {
    onChange(getRandomValue(effectiveMin, effectiveMax, type))
  }

  return (
    <FormControl fullWidth className="input-container">
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">{numericValue}</span>
          <Button variant="outline" size="sm" className="whitespace-nowrap text-xs h-8" onClick={handleRandomClick}>
            Random
          </Button>
        </div>

        <Slider
          value={[numericValue === '' ? effectiveMin : numericValue]}
          min={effectiveMin}
          max={effectiveMax}
          step={type === 'float' ? 0.05 : 1}
          onValueChange={(values) => onChange(values[0])}
          className="flex-1"
        />

        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{labels.left}</span>
          <span>{labels.right}</span>
        </div>
      </div>
    </FormControl>
  )
}

export default RangeType
